import { Dispatch } from 'react';

import {
    AutocompleteTaskDefs,
    AutocompleteReducerAction,
    AutocompleteActionMap,
} from '../types';

export const buildActionMap = <ResultEntry, Value>(
    dispatch: Dispatch<AutocompleteReducerAction<ResultEntry, Value>>
): AutocompleteActionMap<ResultEntry, Value> => ({
    setResults(results) {
        const timestamp = new Date().getTime();
        dispatch({
            type: AutocompleteTaskDefs.SetResults,
            payload: {
                value: results,
                timestamp,
            },
        });
    },
    setValue(value) {
        const timestamp = new Date().getTime();
        dispatch({
            type: AutocompleteTaskDefs.SetValue,
            payload: { value, timestamp },
        });
    },
    reset(value) {
        const timestamp = new Date().getTime();
        dispatch({
            type: AutocompleteTaskDefs.Reset,
            payload: { value, timestamp },
        });
    },
    clear() {
        const timestamp = new Date().getTime();
        dispatch({ type: AutocompleteTaskDefs.Clear, payload: { timestamp } });
    },
    config: {
        setThreshold(threshold) {
            const timestamp = new Date().getTime();
            dispatch({
                type: AutocompleteTaskDefs.SetThreshold,
                payload: { value: threshold, timestamp },
            });
        },
    },
});
